import { useRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import classnames from 'classnames';

import InputError from '@/components/form/Error';
import InputLabel from '@/components/form/Label';

export default function FormInput({
  autoFocus,
  disabled = false,
  name,
  hidden = false,
  visuallyHiddenLabel = false,
  label,
  placeholder,
  required = false,
  type = 'text',
  validation = {},
  className,
  inputClassName,
  dark = false,
}) {
  const inputRef = useRef(null);
  const { errors, register } = useFormContext();

  const isRequired = required ? `${label} is required` : false;
  const isError = errors[name];

  useEffect(() => {
    if (inputRef.current && autoFocus) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const inputClass = classnames(
    'appearance-none border focus:outline-none py-2 px-3 rounded w-full',
    inputClassName,
    {
      'border-red-600': isError,
      'border-gray-300': !isError,
      'cursor-not-allowed opacity-50': disabled,
      'bg-white text-haiti focus:border-cornflower placeholder-gray-600': !dark,
      'bg-bunting-dark placeholder-light-haiti text-white border-bunting-shadow focus:border-white':
        dark,
    },
  );

  return (
    <div
      className={classnames('flex flex-col', { 'mb-4': !hidden }, className)}
    >
      {label && !hidden && (
        <InputLabel
          label={required ? label : `${label} (optional)`}
          htmlFor={name}
          className={`${visuallyHiddenLabel && 'sr-only'}`}
        />
      )}
      <input
        className={inputClass}
        name={name}
        id={name}
        type={hidden ? 'hidden' : type}
        placeholder={placeholder}
        disabled={disabled}
        ref={(e) => {
          register(e, {
            required: isRequired,
            ...validation,
          });
          inputRef.current = e;
        }}
      />
      {isError && <InputError>{errors?.[name]?.message}</InputError>}
    </div>
  );
}
